import { render, staticRenderFns } from "./ButtonShipping.vue?vue&type=template&id=748669aa&scoped=true&"
import script from "./ButtonShipping.vue?vue&type=script&lang=js&"
export * from "./ButtonShipping.vue?vue&type=script&lang=js&"
import style0 from "./ButtonShipping.vue?vue&type=style&index=0&id=748669aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748669aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
